import api from "./api";

/* Tamil voice guide. Mode: "phone" (device speechSynthesis), "cloud" (natural TTS from backend, cached), "off".
   Stored per device (rl_voice) and mirrored on the user (voice_mode).
   One speaker at a time: a new say() silences whatever is playing and drops any older pending cloud fetch. */
let audio = null;
let seq = 0;
export const voiceMode = () => localStorage.getItem("rl_voice") || "off";  // voice guide is opt-in (assist-mode customers); Simple Mode turns it on
export const ensureVoiceOn = () => { if (!localStorage.getItem("rl_voice")) localStorage.setItem("rl_voice", "phone"); };
export const setVoiceMode = (m) => { localStorage.setItem("rl_voice", m); try { api.post("/assist/me", { voice_mode: m }); } catch {} };

const silence = () => {
  try { window.speechSynthesis?.cancel(); } catch {}
  if (audio) { try { audio.pause(); audio.src = ""; } catch {} audio = null; }
};

const phoneSay = (text) => {
  if (!("speechSynthesis" in window)) return false;
  const u = new SpeechSynthesisUtterance(text);
  const v = window.speechSynthesis.getVoices().find((x) => /ta[-_]/i.test(x.lang)) || window.speechSynthesis.getVoices().find((x) => /hi[-_]|en[-_]IN/i.test(x.lang));
  if (v) u.voice = v;
  u.lang = v?.lang || "ta-IN";
  u.rate = 0.92;
  window.speechSynthesis.speak(u);
  return true;
};

export const say = async (text) => {
  const mode = voiceMode();
  if (mode === "off" || !text) return;
  const my = ++seq;
  silence();
  if (mode === "cloud" && navigator.onLine) {
    try {
      const { data } = await api.get("/assist/tts", { params: { text }, responseType: "blob" });
      if (my !== seq) return;  // a newer message replaced this one while it was loading
      silence();
      audio = new Audio(URL.createObjectURL(data));
      await audio.play();
      return;
    } catch { if (my !== seq) return; }
  }
  phoneSay(text);
};

export const stopVoice = () => { seq++; silence(); };
export const taDigits = (n) => String(n).split("").join(" ");
// open WhatsApp/UPI links in a new tab without losing the app page (window.open with "noopener" returns null, so never use it as a fallback test)
export const openExternal = (url) => { const a = document.createElement("a"); a.href = url; a.target = "_blank"; a.rel = "noopener noreferrer"; document.body.appendChild(a); a.click(); a.remove(); };
